module.exports = __webpack_public_path__ + "img/getfrequency.287bbf79.png";